export var TableActionType;
(function (TableActionType) {
    TableActionType[TableActionType["add"] = 0] = "add";
    TableActionType[TableActionType["delete"] = 1] = "delete";
    TableActionType[TableActionType["move"] = 2] = "move";
    TableActionType[TableActionType["editToggle"] = 3] = "editToggle";
    TableActionType[TableActionType["deleteExternal"] = 4] = "deleteExternal";
    TableActionType[TableActionType["editExternal"] = 5] = "editExternal";
})(TableActionType || (TableActionType = {}));
